import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import "./details.scss";
import { OutlineButton } from "../../components/button/Button";

const Details = () => {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [ingredients, setIngredients] = useState([]);
  const iframeRef = useRef(null);
  const [youtubeURL, setYoutubeURL] = useState('')
  useEffect(() => {
    const getDetails = async () => {
      const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/lookup.php?i=${id}`);
      setItem(response.data.meals[0]);
      // console.log(response.data.meals[0]);
      const arr = [];
      Object.keys(response.data.meals[0]).forEach((item, index) => {
        if (response.data.meals[0][`strIngredient${index}`]) {
          arr.push({
            "ingredient": response.data.meals[0][`strIngredient${index}`],
            "measure": response.data.meals[0][`strMeasure${index}`]
          })
        }
      });
      setIngredients(arr);
      setYoutubeURL(response.data.meals[0].strYoutube?.replace('watch?v=', 'embed/'))

      window.scrollTo(0, 0);
      const height = iframeRef.current.offsetWidth * 9 / 16 + 'px';
      iframeRef.current.setAttribute('height', height);
    }
    getDetails();
  }, [id]);
  return (
    <div>
      {
        item && (
          <>
            <div
              className="banner"
              style={{ backgroundImage: `url(${item.strMealThumb})` }}
            >{console.log(item.strMealThumb)}</div>

            <div className="mb-3 movie-content container">
              <div className="movie-content__poster">
                <div
                  className="movie-content__poster__img"
                  style={{ backgroundImage: `url(${item.strMealThumb})` }}></div>
              </div>
              <div className="movie-content__info">
                <h1 className="title">{item.strMeal}</h1>
                {/* <h2>{item.original_title}</h2>
                <h3>{item.spoken_languages[0].english_name}</h3> */}
                {/* {console.log(ingredients)} */}

                <div className="tags">
                  {
                    item.strTags && item.strTags.split(',').map((tag, index) => (
                      <span key={index} className='tags__item'>{tag}</span>
                    ))
                  }
                </div>

                <h2>Ingredients</h2>
                <ul className='ingredients'>
                  {
                    ingredients.length > 0 &&
                    ingredients.map((ingredient, index) => (
                      <li key={index}>
                        <b>{ingredient.ingredient}</b> -
                        <i style={{ opacity: 0.85 }}>{ingredient.measure}</i>
                      </li>
                    ))
                  }
                </ul>

              </div>
            </div>

            <div className="container">
              <div className="section mb-3">
                <div className="video">
                  <div className="video__title">
                    <h2>Instructions</h2>
                  </div>
                  <p>{item.strInstructions}</p>
                </div>
              </div>
            </div>

            <div className="container source">
              <div className="section mb-2">
                <Link to={item.strSource}>
                  <OutlineButton>View Source</OutlineButton>
                </Link>
              </div>
            </div>

            <div className="container">
              <div className="section mb-3">
                <div className="video">
                  <div className="video__title">
                    <h2>Reference Video</h2>
                  </div>
                  <iframe
                    src={youtubeURL ||'https://www.youtube.com/embed=xXPxUtWDTAA'} frameborder="0"
                    ref={iframeRef}
                    width='100%'
                    title={item.name}
                  ></iframe>
                </div>
              </div>
            </div>

          </>
        )
      }
    </div>
  )
}

export default Details